import { ALL_SKILLS } from "./skills-Dj4T8Duc.js";
import { UserInputError } from "./errors-CEDWDXew.js";
import { ParamOrganizationSlug, ParamRegionUrl, ParamSearchQuery } from "./schema-DKEjeVqP.js";
import { defineTool } from "./define-SD6AQa4b.js";
import { apiServiceFromContext } from "./api-EaEPyKlQ.js";
import { structuredResult } from "./results-NF1RJbDZ.js";
import { z } from "zod";
import { setTag } from "@sentry/core";

//#region src/tools/catalog/find-projects.ts
const RESULT_LIMIT = 25;
const findProjectsOutputSchema = z.object({
	projects: z.array(z.object({ slug: z.string() })),
	hasMore: z.boolean()
});
var find_projects_default = defineTool({
	name: "find_projects",
	skills: ALL_SKILLS,
	requiredScopes: ["project:read"],
	description: [
		"Find projects in Sentry.",
		"",
		"Use this tool when you need to:",
		"- View projects in a Sentry organization",
		"- Find a project's slug to aid other tool requests",
		"- Search for specific projects by name or slug",
		"",
		`Returns up to ${RESULT_LIMIT} results. When hasMore is true, use the query parameter to narrow down results.`
	].join("\n"),
	inputSchema: {
		organizationSlug: ParamOrganizationSlug,
		regionUrl: ParamRegionUrl.nullable().default(null),
		query: ParamSearchQuery.nullable().default(null)
	},
	annotations: {
		readOnlyHint: true,
		destructiveHint: false,
		openWorldHint: true
	},
	outputSchema: findProjectsOutputSchema,
	async handler(params, context) {
		const apiService = apiServiceFromContext(context, { regionUrl: params.regionUrl ?? void 0 });
		const organizationSlug = params.organizationSlug;
		if (!organizationSlug) throw new UserInputError("Organization slug is required. Please provide an organizationSlug parameter.");
		setTag("organization.slug", organizationSlug);
		const projects = await apiService.listProjects(organizationSlug, {
			query: params.query ?? void 0,
			limit: RESULT_LIMIT + 1
		});
		return structuredResult({
			projects: projects.slice(0, RESULT_LIMIT).map((project) => ({ slug: project.slug })),
			hasMore: projects.length > RESULT_LIMIT
		});
	}
});

//#endregion
export { findProjectsOutputSchema, find_projects_default };
//# sourceMappingURL=find-projects-BYeZfQDF.js.map